import { useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { ChartConfig, ChartType } from 'types/charts';

import { useCostOverTime } from '../../../../../../cost-report/hooks/useCostOverTime';
import { useCostReportContext } from '../../../../../../cost-report/hooks/useCostReportContext';
import {
  CostReportChartType,
  NormalizedCostMode,
} from '../../../../../../cost-report/types/costOverTime';
import { useNormalizedCostsControls } from '../../_hooks/useNormalizedCostControls';

const useModes = () => {
  const theme = useTheme();
  return [
    { mode: NormalizedCostMode.NORMALIZED, color: theme.palette.blue[700]! },
    { mode: NormalizedCostMode.ON_DEMAND, color: theme.palette.blue[300]! },
    { mode: NormalizedCostMode.FALLBACK, color: theme.palette.yellow[200]! },
    { mode: NormalizedCostMode.SPOT, color: theme.palette.indigo[800]! },
  ];
};

export const useNormalizedCostChartConfig = (): ChartConfig[] => {
  const { chartType } = useCostReportContext();
  const { activeTab } = useNormalizedCostsControls();
  const { projectEndOfDayCost } = useCostOverTime();
  const modes = useModes();

  if (chartType === CostReportChartType.AREA) {
    return modes.map(({ mode, color }) => ({
      type: ChartType.AREA,
      enabled: activeTab === mode,
      config: { dataKey: mode, fill: color },
    }));
  }

  const barDefaults = { maxBarSize: 20 };
  const type = ChartType.BAR;
  const stackId = 'a';

  return modes.flatMap(({ mode, color }) => {
    const enabled = activeTab === mode;
    return [
      {
        type,
        enabled,
        stackId,
        config: { dataKey: mode, fill: color, ...barDefaults },
      },
      {
        type,
        stackId,
        enabled: projectEndOfDayCost && enabled,
        config: {
          dataKey: `${mode}ForecastDelta`,
          fill: 'none',
          stroke: alpha(color, 0.6),
          ...barDefaults,
        },
      },
    ];
  });
};
